/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import constants from '../../../constants/constants';
import InputWrapper from './InputWrapper';
import { AppContext } from '../../../context/appContext';

const AddressData = ({ delivery, addAddressData, addressData }) => {
  const [settings] = useContext(AppContext);
  return (
    <>
      <InputWrapper bgcolor={settings?.orderInputBg || `#e7c37a`}>
        <label htmlFor="zip">Irányítószám</label>
        <input
          required={delivery}
          name="zip"
          id="zip"
          onChange={addAddressData}
          value={addressData.zip}
        />
      </InputWrapper>
      <InputWrapper bgcolor={settings?.orderInputBg || `#e7c37a`}>
        <label htmlFor="city">Város</label>
        <input
          required={delivery}
          name="city"
          id="city"
          onChange={addAddressData}
          value={addressData.city}
        />
      </InputWrapper>
      <InputWrapper bgcolor={settings?.orderInputBg || `#e7c37a`}>
        <label htmlFor="street">Közterület neve</label>
        <input
          required={delivery}
          name="street"
          id="street"
          onChange={addAddressData}
          value={addressData.street}
        />
      </InputWrapper>
      <InputWrapper bgcolor={settings?.orderInputBg || `#e7c37a`}>
        <label htmlFor="streetType">Közterület típusa</label>
        <select
          required={delivery}
          id="streetType"
          name="streetType"
          onChange={addAddressData}
          value={addressData.streetType}
          type="select"
        >
          <option value="">Kérjük válassz</option>
          {constants.streetTypes.map(type => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </InputWrapper>
      <InputWrapper
        className="houseBox"
        bgcolor={settings?.orderInputBg || `#e7c37a`}
      >
        <label htmlFor="house">Házszám</label>
        <input
          required={delivery}
          name="house"
          id="house"
          onChange={addAddressData}
          value={addressData.house}
        />
      </InputWrapper>
    </>
  );
};

export default AddressData;

AddressData.propTypes = {
  delivery: PropTypes.bool.isRequired,
  addAddressData: PropTypes.func.isRequired,
  addressData: PropTypes.shape({
    zip: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    streetType: PropTypes.string,
    house: PropTypes.string
  }).isRequired
};
